// removed by extract-text-webpack-plugin
module.exports = {"root":"_1GbPS","pop-in":"_XybUn","hide":"_1l-Mb","paymentInfo":"_2JX_P","paymentTitle":"_1wGl7","bankingTextList":"_Ngw-Y","details":"_2CK5E","bankList":"_1izI0","backListItem":"_3nDh-","active":"_AeVWc","bankLogoImage":"_3bJsV","jelly":"_jbuon","slideInLeft":"_2UpME","slideInUp":"_1pKmN","fadeIn":"_1b81Z","spin":"_2M1BH"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PaymentHandler/PayBy2C2P/PayBy2C2P.scss
// module id = 1534
// module chunks = 1